import script from "./refundProduct.vue?vue&type=script&setup=true&lang=js"
export * from "./refundProduct.vue?vue&type=script&setup=true&lang=js"

import "./refundProduct.vue?vue&type=style&index=0&id=0d83dd62&lang=scss&scoped=true"
import "./refundProduct.vue?vue&type=style&index=1&id=0d83dd62&lang=css"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d83dd62"]])

export default __exports__